import { Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import useCustomerStore from "../../../stores/useCustomerStore";
import { useEffect, useState } from "react";
import index from "../../../api/auth/customers";
import { Edit } from "@mui/icons-material";
import OrderCustomerForm from "./OrderCustomerForm";
import CustomerCard from "../../displays/customers/CustomerCard";
import OrderReservationForm from "./OrderReservationForm";
import OrderLocationForm from "./OrderLocationForm";
import LocationCard from "../../displays/locations/LocationCard";
import OrderCommentForm from "./OrderCommentForm";

export default function OrderForm({ order }) {
  const [ editCustomer, setEditCustomer ] = useState(!order.customer_id);
  const [ editDelivery, setEditDelivery ] = useState(!order.location_id);
  const { customers, setCustomers } = useCustomerStore();

  useEffect(() => {
    if(customers.length === 0) {
      index((response) => {
        setCustomers(response);
      });
    }
  }, []);

  console.log(order);

  return (
    <Stack>
      <Stack>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <Stack direction="row">
              <Typography variant="h4">Customer Information</Typography>
              {order.customer_id && <IconButton onClick={() => setEditCustomer(!editCustomer)}>
                <Edit />
              </IconButton>}
            </Stack>
            <Stack>
              {editCustomer ?
                <OrderCustomerForm order={order} afterUpdate={() => setEditCustomer(false)} /> :
                <CustomerCard customer={order.customer}
              />}
            </Stack>
          </Grid>
          <Grid item sm={6}>
            <Stack direction="row">
              <Typography variant="h4">Delivery Information</Typography>
              {order.customer_id && <IconButton onClick={() => setEditDelivery(!editDelivery)}>
                <Edit />
              </IconButton>}
            </Stack>
            <Stack>
              {editDelivery ? <OrderLocationForm order={order} afterUpdate={() => setEditDelivery(false)} /> : <LocationCard location={order.location} />}
            </Stack>
          </Grid>
        </Grid>
        <Stack my={2}>
          <Divider />
        </Stack>
        <Stack>
          <OrderCommentForm order={order} />
        </Stack>
        <Stack my={2}>
          <Divider />
        </Stack>
        <Stack>
          <Typography variant="h4">Reservation Information</Typography>
        </Stack>
        <Stack>
          <OrderReservationForm order={order} />
        </Stack>
      </Stack>
    </Stack>
  );
}